<template>
  <div>
    <div v-for="field in fields" :key="field.name">
      <div :class="{
            'input-field': true,
             'input-outlined': true,
             'required': field.required,
             'bordered': field.required,
             'requiredFilled': Object.prototype.hasOwnProperty.call(group, field.fieldname) && group[field.fieldname] !== ''
            }">


        <label
            v-if="field.label !== ''"
            :for="field.id"
            class="active">
          <span>{{field.label}}</span>
          <a
              v-if="field.description !== ''"
              class="tooltipped"
              data-position="right"
              data-delay="50"
              :data-tooltip="field.description">
            <i class="material-icons">info</i>
          </a>
        </label>

        <input
            v-if="field.type === 'Asd_String'"
            type="text"
            :name="field.name"
            :value="group[field.fieldname]"
            :id="field.id"
        />

        <select
            v-else-if="field.type === 'Asd_Select'"
            type="text"
            :name="field.name"
            :id="field.id"
            :multiple="field.multiple"
        >
          <option v-for="option in field.list"
                   :key="option.value"
                   :value="option.value"
                   :selected="option.selected || option.checked"
                   :disabled="option.disabled"
          >{{option.text}}</option>
        </select>

        <input
            v-else-if="field.type === 'Hidden'"
            type="hidden"
            :name="field.name"
            :value="group[field.fieldname]"
            :id="field.id"
        />

        <div
            v-else-if="field.type === 'Asd_Date'"
            class="row">
          <div class="col s1">
            <button class="btn btn-floating" :id="field.id+'_toggler'" type="button">
              <i class="material-icons">event</i>
            </button>
          </div>
<!--          <div class="col s8 input-field input-outlined" v-if="group[field.fieldname] !== '0000-00-00' && group[field.fieldname] !=='0000-00-00 00:00:00'">-->
<!--            <FlatPickr-->
<!--                :name="field.name"-->
<!--                :id="field.id"-->
<!--                v-model="group[field.fieldname]"-->
<!--            ></FlatPickr>-->
<!--          </div>-->
          <!--            <input-->
          <!--                :id="field.id"-->
          <!--                type="text"-->
          <!--                class="datepicker"-->
          <!--                :name="field.name"-->
          <!--                :value="(!(group[field.fieldname] === '0000-00-00' || group[field.fieldname] ==='0000-00-00 00:00:00')) ? group[field.fieldname] : ''">-->
          <div class="col s8 input-field input-outlined">
            <FlatPickr
                :name="field.name"
                :id="field.id"
                v-model="group[field.fieldname]"
                :config="flatpickr_config"
            ></FlatPickr>
          </div>
          <div class="col s1">
            <button class="btn-floating" id="<?php echo $id; ?>_reset" type="button">
              <i class="material-icons">cancel</i>
            </button>
          </div>
        </div>

        <div v-else-if="field.type === 'Asd_Files'">
          <file-upload
              :ref="field.id+'_filess'"
              :files="group[field.fieldname]"
          >
            <button class="btn red lighten-4">Uplaod</button>
          </file-upload>
        </div>

        <p
          v-else
          style="margin: 30px 0 15px; background-color: green">
          <strong :style="field.required ? 'background-color: red' : ''">{{field.name}} ({{field.type}})</strong>: <span>{{group[field.fieldname]}}</span>
        </p>

      </div>
    </div>

  </div>

</template>

<script>

import Vue from 'vue';

export default {
  name: "GroupEdit",

  props: {
    group: {
      required: true,
      type: Object
    },
    id: {
      required: true,
      type: Number,
    },
    fields: {
      required: true,
      type: Array,
    }
  },

  data: () => {
    return {
      // fields: [],
      missings: [],
      saving: false,
      tempDates: {},
      enableDates: false,
      flatpickr_config: {
        static: true,
        altInput: true,
        altFormat: "D j M Y",

        monthSelectorType: 'dropdown',
      }
    }
  },

  methods: {
    actualSave: function (fakeError = false) {
      console.log('Bambolized!', fakeError);
      this.saving = true;
      // TODO implement here
      window.setTimeout(() => {

        this.saving = false;
        this.closeModal('edit_groupData');

        if (!fakeError) {
          this.make('Dati del gruppo salvati');

          this.calcPerc();
        } else {
          this.make('Errore');
        }
      }, 2000);
    },
  },

  mounted: function () {
    // console.log('MOUNTED');
    // window.setTimeout( () => {
    //
    // }, 500);
    let tooltips = document.querySelectorAll('.tooltipped');
    M.Tooltip.init(tooltips, {"exitDelay": 10});

    var selects = document.querySelectorAll('select');
    for (let i=0; i<selects.length; i++) {
      if (selects[i].classList.contains('browser-default')) continue;
      if (selects[i].classList.contains('flatpickr-monthDropdown-months')) continue;
      if (selects[i].classList.contains('search')) continue;
      M.FormSelect.init(selects[i], {});
    }

    // initPickers('flatpickr');
  },

  created() {
    // console.log('CREATED');
    for (let field of this.fields) {
      if (field.type === 'Asd_Date') {
        if (this.group[field.fieldname] === '0000-00-00' || this.group[field.fieldname] === '0000-00-00 00:00:00') {
          Vue.set(this.group, field.fieldname, '');
        }
      }
    }
    // console.log('created result: ', this.tempDates);
    this.enableDates = true;
  }
}


</script>
